import { useEffect, useState } from "react";
import { Modal, Form, Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";

import { fetchWithToken } from "../../../interceptors/fetchInterceptor";

import { handleValidityMonthsDisabled } from "../../AdministrativeProcedures/technicalExaminationAppRHF/TableOptions";

import {
  addNewEngineCheck,
  addNewSpecMarkApp,
  addNewDealApp,
} from "../../../redux/statementReducer/actionsStatement";
import {
  addNewCulprit,
  addNewInjured,
} from "../../../redux/TransportAccidentsReportReducer/actionsTransportAccidentsReport";
import { addNewTechExamTableInfo } from "../../../redux/TechnicalExaminationReducer/actionsTechnicalExamination";

import {
  MAIN_URL,
  PORT,
  API_CHECK_ENGINES_MODIF,
  API_ADD_NEW_ENGINE_CHECK,
  API_ADD_NEW_ENGINE_CHECK_STATIC,
} from "../../../constants/constants";

import {
  customStyles,
  customErrorStyles,
} from "../../GeneralComponents/componentsForFormUniversal/selectWithSearchUniversal/optionsSelectWithSearch";

import styles from "./universalModalWindow.module.css";

export default function UniversalModalWindow({
  appData,
  updateData,
  setShowModal,
  showModal,
  modalWindowInputs,
  dataForCheck,
  mainData,
  dataForEdit,
  setDataForEdit,
  setDefaultOptions,
  handleAdditionalAction,
}) {
  const [newData, setNewData] = useState({});
  const [errors, setErrors] = useState({});
  const [saveKey, setSaveKey] = useState(false);
  const [textCheckEngine, setTextCheckEngine] = useState(null);

  const dispatch = useDispatch();

  const dictionaryReducer = useSelector((state) => {
    const { dictionaryReducer } = state;
    return dictionaryReducer;
  });

  const [errorsFields, setErrorsFields] = useState(
    Object.values(modalWindowInputs.nameColumn)
      .filter((item) => item.neededInModal)
      .filter((item) => (item.required !== undefined ? item.required : item.neededInModal))
      .map((item) => Object.values(item))
      .map((elem) => elem[1])
      .filter((elem) => elem !== "asmLock" && elem !== "msmLock" && elem !== "actDate" && elem !== "recuser"),
  );

  const resultCheck = async (keyTable) => {
    if (window.location.pathname.includes("reginformationchanges")) {
      const responseEngine = await fetchWithToken(MAIN_URL + PORT + API_CHECK_ENGINES_MODIF, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ engineVin: newData.engvin, engname: newData.engname }),
      });
      if (responseEngine.ok) {
        if (!JSON.parse(await responseEngine.text())) {
          setTextCheckEngine("Данный двигатель установлен на другой лодке");
        } else {
          updateData(modalWindowInputs.keyTable, newData);
          setShowModal(false);
          setNewData({});
        }
      } else {
        setTextCheckEngine("Ошибка на сервере");
      }
    }
    if (window.location.pathname.includes("smallboatsreg")) {
      switch (keyTable) {
        case "boatCardAppEngDtoList":
          {
            newData.engpwr = newData.engpwr.replace(",", ".");
            if (Number(newData.engpwr) > Number(appData.engpwrmax)) {
              setTextCheckEngine(
                `Предельная мощность двигателя не должна превышать ${appData.engpwrmax} л.с.`,
              );
            } else if (
              !newData.innerId &&
              dataForCheck.findIndex((item) => item.engvin === newData.engvin) >= 0
            ) {
              setTextCheckEngine(`Двигатель с заводским номером ${newData.engvin} уже добавлен`);
            } else {
              const request = await fetchWithToken(MAIN_URL + PORT + API_ADD_NEW_ENGINE_CHECK, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ engineVin: newData.engvin, engname: newData.engname }),
              });
              if (request.ok) {
                const data = await request.text();
                if (data !== "OK") {
                  setTextCheckEngine(data);
                } else {
                  dispatch(addNewEngineCheck(newData, modalWindowInputs.keyTable));
                  setNewData({});
                  setDataForEdit({});
                  setShowModal(false);
                }
              }
            }
          }
          break;
        case "boatCardAppEngStaticDtoList":
          {
            let summaryEngPwr = 0;
            newData.engpwr = newData.engpwr.replace(",", ".");
            if (!newData.innerId) {
              summaryEngPwr =
                Number(newData.engpwr.replace(",", ".")) +
                dataForCheck.reduce((acc, cur) => Number(acc) + Number(cur.engpwr), 0);
            } else {
              summaryEngPwr = dataForCheck.reduce(
                (acc, cur) =>
                  Number(acc) +
                  ((cur.innerId !== newData.innerId && Number(cur.engpwr)) ||
                    Number(newData.engpwr.replace(",", "."))),
                0,
              );
            }

            if (summaryEngPwr > appData.engpwrmax) {
              setTextCheckEngine(
                `Суммарная предельная мощность двигателей не должна превышать ${appData.engpwrmax} л.с.`,
              );
            } else if (
              !newData.innerId &&
              dataForCheck.findIndex((item) => item.engnum === newData.engnum) >= 0
            ) {
              setTextCheckEngine(`Двигатель с заводским номером ${newData.engnum} уже добавлен`);
            } else {
              const request = await fetchWithToken(
                MAIN_URL + PORT + API_ADD_NEW_ENGINE_CHECK_STATIC + newData.engnum,
                {
                  method: "POST",
                },
              );
              if (request.ok) {
                const data = await request.text();
                if (data !== "OK") {
                  setTextCheckEngine(data);
                } else {
                  dispatch(addNewEngineCheck(newData, modalWindowInputs.keyTable));
                  setNewData({});
                  setDataForEdit({});
                  setShowModal(false);
                }
              }
            }
          }
          break;

        default:
          break;
      }
    }
  };
  const countEnginesMaxPower = () => {
    const count = dataForCheck.reduce((acc, current) => {
      if (!current.dateRegEnd) {
        return acc + parseFloat(current.engpwr);
      }
      return acc;
    }, 0);
    return count;
  };
  const countEnginesCheck = () => {
    const count = dataForCheck.reduce((acc, current) => {
      if (!current.dateRegEnd) {
        return acc + 1;
      }
      return acc;
    }, 0);

    return count;
  };
  // const calculatePeriodOfValidity = (result) => {
  //   switch (true) {
  //     case !result:
  //       newData["validityMonths"] = 0;
  //       break;
  //     case new Date().getFullYear() - Number(dataTechExam.boatYear) >= 10:
  //       newData["validityMonths"] = 12;
  //       break;
  //     // case new Date().getFullYear() - Number(dataTechExam.boatYear) < 10:
  //     //   newData["validityMonths"] = 12;
  //     //   break;
  //     default:
  //       break;
  //   }
  //   setNewData(structuredClone(newData));
  //   // if (!newData.result) {
  //   //   newData["validityMonths"] = 0;
  //   // }
  //   // if (new Date().getFullYear() - Number(dataTechExam.boatYear) >= 10) {
  //   //   newData["validityMonths"] = 12;
  //   // }
  // };

  const handleChange = (e) => {
    if (e.key) {
      if (e.key === "result") {
        if (!e.value) {
          setErrorsFields(structuredClone([...errorsFields, "actDate", "recuser"]));
          newData["validityMonths"] = 0;
          newData["recuser"] = dictionaryReducer.userInfo?.userid;
          newData["actDate"] = new Date().toLocaleDateString().split(".").reverse().join("-");
          modalWindowInputs = handleValidityMonthsDisabled(e.value);
        } else {
          setErrorsFields(
            structuredClone(errorsFields.filter((item) => item !== "actDate" && item !== "recuser")),
          );
          newData["validityMonths"] = null;
          delete newData["recuser"];
          delete newData["actDate"];
          modalWindowInputs = handleValidityMonthsDisabled(e.value);
        }
      }
      newData[e.key] = e.value;
      setNewData(structuredClone(newData));
    } else {
      if (e.target.dataset.id === "asmLock" || e.target.dataset.id === "msmLock") {
        newData[e.target.dataset.id] = Boolean(e.currentTarget.value);
      } else if (e.target.dataset.id === "toDate") {
        newData[e.target.dataset.id] = e.currentTarget.value;
        newData["actDate"] = e.currentTarget.value;
      } else {
        newData[e.target.dataset.id] = e.currentTarget.value;
      }
    }
    setNewData(structuredClone(newData));
    if (saveKey) handleErrors();
  };

  const handleErrors = () => {
    let newErrors = {};

    errorsFields.forEach((elem) => {
      if (elem !== "asmLock" && elem !== "msmLock" && elem !== "result" && elem !== "validityMonths") {
        if (!newData[elem] || newData[elem] === "") {
          newErrors[elem] = "Заполните поле";
        }
        if (elem === "docDate") {
          if (new Date(newData[elem]) > new Date()) {
            newErrors[elem] = "Дата не может быть позднее текущей";
          }
        }
        if (elem === "engProdYear") {
          if (new Date(newData[elem]) && new Date(newData[elem]).getFullYear() > new Date().getFullYear()) {
            newErrors[elem] = "Дата не может быть позднее текущей";
          }
        }
        if (
          elem === "birthDate" &&
          (modalWindowInputs.keyTable === "causersList" || modalWindowInputs.keyTable === "victimsList")
        ) {
          if (new Date(newData[elem]) > new Date()) {
            newErrors[elem] = "Дата не может быть позднее текущей";
          }
        }
        if (elem === "toDate") {
          if (new Date(newData[elem]) > new Date()) {
            newErrors[elem] = "Дата не может быть позднее текущей";
          }
        }
      } else {
        if (!newData.hasOwnProperty(elem) || newData[elem] === null) {
          newErrors[elem] = "Заполните поле";
        }
      }
    });

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return true;
    } else {
      setErrors({});
      return false;
    }
  };

  const handleSave = () => {
    if (!handleErrors()) {
      switch (true) {
        case window.location.pathname.includes("reginformationchanges"):
          switch (modalWindowInputs.keyTable) {
            case "enginesList":
              if (
                dataForCheck.find(
                  (item) =>
                    item.engvin === newData.engvin &&
                    item.engtype === (newData.engtype === "1" ? "Бензиновый" : "Электрический") &&
                    item.engProdYear === newData.engProdYear,
                )
              ) {
                setTextCheckEngine("Двигатель установлен на данном судне");
                break;
              }
              if (!(mainData.engineNum >= countEnginesCheck() + 1)) {
                setTextCheckEngine("Превышает допустимое количество двигателей");
                break;
              }
              if (!(mainData.engpwrmax > countEnginesMaxPower() + parseFloat(newData.engpwr))) {
                setTextCheckEngine("Превышает допустимую предельную мощность двигателей");
                break;
              }

              resultCheck();
              break;
            default:
              updateData(modalWindowInputs.keyTable, newData);
              setShowModal(false);
          }
          break;
        default:
          switch (modalWindowInputs.keyTable) {
            case "boatCardAppEngDtoList":
              resultCheck("boatCardAppEngDtoList");
              return;
            case "boatCardAppEngStaticDtoList":
              resultCheck("boatCardAppEngStaticDtoList");
              return;
            case "boatCardAppSmDtoList":
              dispatch(addNewSpecMarkApp(newData));
              setDataForEdit({});
              break;
            case "boatCardAppDealsDtoList":
              dispatch(addNewDealApp(newData));
              setDataForEdit({});
              break;
            case "causersList":
              dispatch(addNewCulprit(newData));
              setDataForEdit({});
              break;
            case "victimsList":
              dispatch(addNewInjured(newData));
              setDataForEdit({});
              break;
            case "boatTo":
              dispatch(addNewTechExamTableInfo(newData));
              break;
            default:
              setShowModal(false);
              setNewData({});
              break;
          }
          setShowModal(false);
          setNewData({});
          break;
      }
    } else {
      setSaveKey(true);
    }
  };

  useEffect(() => {
    let input = null;
    if (Object.values(newData).length === 0 && Object.values(dataForEdit).length === 0) {
      switch (modalWindowInputs.keyTable) {
        // case "boatCardAppEngDtoList":
        //   setNewData({ engtype: 1 });
        //   break;
        case "boatCardAppSmDtoList":
          setNewData({ asmLock: true });
          input = document.querySelector("#locked");
          input.toggleAttribute("checked");
          break;
        // case "enginesList":
        //   setNewData({ engtype: 1 });
        //   break;
        case "boatCardSpecmarksList":
          setNewData({ msmLock: true });
          input = document.querySelector("#locked");
          input.toggleAttribute("checked");
          break;
        case "causersList":
          // setNewData({ drunk: true });
          break;
        case "victimsList":
          setNewData({ drunk: true });
          break;
        case "boatTo":
          setNewData({
            toUserid: dictionaryReducer.userInfo?.userid,
            toDate: new Date().toLocaleDateString().split(".").reverse().join("-"),
            actDate: new Date().toLocaleDateString().split(".").reverse().join("-"),
          });
          break;
        default:
          break;
      }
    }
  }, []);

  useEffect(() => {
    if (Object.values(dataForEdit).length > 0 && Object.values(newData).length === 0) {
      setNewData({ ...dataForEdit });
    }
  }, [dataForEdit]);

  return (
    <Modal
      show={showModal}
      onHide={() => {
        setShowModal(false);
        setNewData({});
        setDefaultOptions && setDefaultOptions();
      }}>
      <Modal.Header
        closeButton
        className={styles["form-header"]}>
        <Modal.Title className={styles["form-title"]}>{modalWindowInputs.caption}</Modal.Title>
      </Modal.Header>
      <Modal.Body className={styles["form-body"]}>
        <Form className={styles["form-inputs-container"]}>
          {Object.values(modalWindowInputs.nameColumn).map((item) => {
            if (item.neededInModal) {
              if (item.fieldModeView) {
                return (
                  <div className={`${styles["text-block"]} ${styles?.[`box-${item.key}`]}`}>
                    <p className={styles["option-label"]}>{item.value}</p>
                    <p className={styles["option-value"]}>
                      {item.type === "customSelect"
                        ? item.selectOptions.find((elem) => elem.value === newData?.[item.key])?.label || "—"
                        : item.type === "date" && newData?.[item.key]
                        ? newData?.[item.key].split("-").reverse().join(".")
                        : newData?.[item.key] || "—"}
                    </p>
                  </div>
                );
              } else {
                switch (item.type) {
                  case "select":
                    return (
                      <Form.Group className={styles["input-container"]}>
                        <label>
                          {item.value}
                          {item.required && <span className={styles["red-dot"]}>*</span>}
                        </label>
                        <Form.Select
                          data-id={item.key}
                          type="select"
                          isInvalid={!!errors[item.key]}
                          onChange={(e) => {
                            handleChange(e);
                          }}>
                          {item.selectOptions.map((elem) => (
                            <option
                              data-id={item.key}
                              value={elem.value}>
                              {elem.label}
                            </option>
                          ))}
                        </Form.Select>
                      </Form.Group>
                    );
                  case "customSelect":
                    return (
                      <Form.Group className={styles["input-container"]}>
                        <label className={styles["label"]}>
                          {item.value}
                          {item.required && <span className={styles["red-dot"]}>*</span>}
                        </label>
                        <Select
                          noOptionsMessage={() => "Нет данных"}
                          classNamePrefix="react-select"
                          styles={errors[item.key] ? customErrorStyles : customStyles}
                          placeholder={item.placeholder || "Выберите"}
                          data-id={item.key}
                          onChange={(e) => handleChange(e)}
                          value={(() => {
                            if (newData.hasOwnProperty(item.key)) {
                              if (item) {
                                return item?.selectOptions?.find((item) => item.value == newData[item.key]);
                              }
                            }
                          })()}
                          isSearchable={false}
                          isDisabled={item.disabled}
                          name={item.key}
                          options={item.selectOptions}
                        />
                      </Form.Group>
                    );
                  case "date":
                    return (
                      <Form.Group className={styles["input-container"]}>
                        <label className={styles["label"]}>
                          {item.value}
                          {item.required && <span className={styles["red-dot"]}>*</span>}
                        </label>
                        <input
                          className={`${styles["form-input"]} ${
                            errors[item.key] ? styles["red-border"] : ""
                          }`}
                          data-id={item.key}
                          type="date"
                          value={newData[item.key]}
                          // isInvalid={!!errors[item.key]}
                          onChange={(e) => {
                            handleChange(e);
                          }}
                        />
                        {errors[item.key] && <div style={{ color: "red" }}>{errors[item.key]}</div>}
                      </Form.Group>
                    );
                  case "checkbox":
                    return (
                      <Form.Group className={styles["input-container"]}>
                        <label className={styles["label"]}>
                          {item.value}
                          {item.required && <span className={styles["red-dot"]}>*</span>}
                        </label>
                        <div className={styles["checkbox-container"]}>
                          <input
                            className={styles["checkbox-radio"]}
                            name={item.value}
                            data-id={item.key}
                            id="locked"
                            type="radio"
                            // checked={newData.bsmLock === undefined ? true : false}
                            value={1}
                            onChange={(e) => {
                              handleChange(e);
                            }}
                          />
                          <label for="locked">{"Да"}</label>
                        </div>
                        <div className={styles["checkbox-container"]}>
                          <input
                            className={styles["checkbox-radio"]}
                            name={item.value}
                            data-id={item.key}
                            id="unlocked"
                            type="radio"
                            value={""}
                            onChange={(e) => {
                              handleChange(e);
                            }}
                          />
                          <label for="unlocked">{"Нет"}</label>
                        </div>
                      </Form.Group>
                    );
                  default:
                    return (
                      <Form.Group className={styles["input-container"]}>
                        <label className={styles["label"]}>
                          {item.value}
                          {item.required && <span className={styles["red-dot"]}>*</span>}
                        </label>
                        <input
                          className={`${styles["form-input"]} ${
                            errors[item.key] ? styles["red-border"] : ""
                          }`}
                          data-id={item.key}
                          type={item.type}
                          placeholder={item.placeholder || "Введите"}
                          isInvalid={!!errors[item.key]}
                          value={newData[item.key]}
                          onChange={(e) => {
                            handleChange(e);
                          }}
                        />
                        {errors[item.key] && <div style={{ color: "red" }}>{errors[item.key]}</div>}
                      </Form.Group>
                    );
                }
              }
            }
          })}
          {textCheckEngine && (
            <label className={`text-danger`}>{textCheckEngine ? textCheckEngine : ""}</label>
          )}
        </Form>
      </Modal.Body>
      <Modal.Footer className={styles["form-footer"]}>
        <button
          id="save"
          className={styles["save-btn"]}
          onClick={handleSave}>
          {"Сохранить"}
        </button>
      </Modal.Footer>
    </Modal>
  );
}
